import { Auth } from 'aws-amplify';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
  FORWARD_BASE_URL,
  FORWARD_KEY,
  TRANSACTIONAL_BASE_URL,
  TRANSACTIONAL_KEY
} from '../apiRoutes';

axios.defaults.headers['Accept-Language'] = 'pt';
// Sem isso, uma conexão que trava (comum quando o backend compartilhado está
// sobrecarregado) fica pendurada indefinidamente - o axios não tem timeout
// por padrão. Sem erro nem sucesso, a tela fica "carregando" pra sempre (ex.:
// lista de NFS-e). 30s dá margem confortável pra chamadas normais (o teto de
// Lambda/API Gateway já usado no financeiro é 29s) e garante que uma conexão
// travada falhe de forma limpa e catável em vez de nunca resolver.
axios.defaults.timeout = 30000;

// Marca quando cada requisição começou, pra distinguir uma falha rápida
// (bug, validação no backend etc.) de uma falha genuinamente lenta (perto do
// timeout de 30s) — sem isso, qualquer 500/502/503/504 dava a mesma mensagem
// de "aguarde, está demorando", mesmo quando a resposta voltou em poucos ms.
axios.interceptors.request.use((config) => {
  config.metadata = { inicio: Date.now() };
  return config;
});
axios.interceptors.response.use(undefined, (error) => {
  if (error?.config?.metadata?.inicio) {
    error.duracaoMs = Date.now() - error.config.metadata.inicio;
  }
  return Promise.reject(error);
});

// O preflight (OPTIONS) é feito pelo próprio navegador quando necessário; um OPTIONS
// manual antes de cada GET dobrava as idas ao servidor sem trazer garantia extra.

async function simpleSecManGet(path) {
  try {
    const response = await axios.get(`${FORWARD_BASE_URL}${path}`, {
      headers: {
        'x-api-key': FORWARD_KEY
      }
    });
    return response;
  } catch (error) {
    handleErrors(error);
  }
}

async function secretsManagerGet(path) {
  try {
    const response = await axios.get(`${FORWARD_BASE_URL}${path}`, {
      headers: {
        'x-api-key': FORWARD_KEY
      }
    });
    return response;
  } catch (error) {
    handleErrors(error);
  }
}

async function secretsManagerPost(path, data) {
  console.log('path no secretsManagerPost:', path);
  return axios
    .post(path, data, {
      headers: {
        'x-api-key': FORWARD_KEY
      }
    })
    .then((response) => response)
    .catch((error) => {
      handleErrors(error);
    });
}

async function transactionalGet(path) {
  try {
    const response = await axios.get(`${TRANSACTIONAL_BASE_URL}${path}`, {
      headers: {
        'x-api-key': TRANSACTIONAL_KEY
      }
    });
    return response;
  } catch (error) {
    handleErrors(error);
  }
}

async function transactionalCustomGet(path) {
  try {
    const response = await axios.get(`${TRANSACTIONAL_BASE_URL}${path}`, {
      headers: {
        'x-api-key': TRANSACTIONAL_KEY
      }
    });
    return response;
  } catch (error) {
    customError(error);
  }
}

export const http = {
  get,
  getSilent,
  post,
  put,
  remove,
  simpleGet,
  simpleGetSilent,
  customMessageGet,
  simplePost,
  simplePut,
  voidPut,
  dlmPut,
  returnPut,
  voidRemove,
  altPost,
  voidPost,
  toastPost,
  dlmPost,
  blobGet,
  voidGet,
  secretsManagerGet,
  simpleSecManGet,
  secretsManagerPost,
  transactionalGet,
  transactionalCustomGet
};

const config = {
  position: 'top-right',
  autoClose: '6000',
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

async function simpleGet(path) {
  return axios
    .get(path, {
      headers: {}
    })
    .then((response) => response)
    .catch((error) => {
      handleErrors(error);
    });
}

// Igual a simpleGet, mas sem toast — mesmo motivo do getSilent (chamadas de
// fundo com retry/degradação silenciosa próprios).
async function simpleGetSilent(path) {
  return axios
    .get(path, {
      headers: {}
    })
    .then((response) => response)
    .catch((error) => {
      console.error(error);
      throw error;
    });
}

// Make the Price BaseURL = https://tqbtej6d7l.execute-api.us-east-1.amazonaws.com
// Elementar BaseURL = https://uo8q51ckb3.execute-api.us-east-1.amazonaws.com

async function blobGet(path) {
  return axios
    .get(path, { responseType: 'arraybuffer' })
    .then((response) => response)
    .catch((error) => {
      handleErrors(error);
    });
}

async function simplePost(path, data) {
  return axios
    .post(path, data)
    .then((response) => response)
    .catch((error) => {
      postErrors(error);
    });
}

async function get(path, token) {
  return axios
    .get(path, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      handleErrors(error);
    });
}

async function voidGet(path, token) {
  return axios
    .get(path, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      console.log(error);
    });
}

// Igual a `get`, mas sem toast: usado por chamadas de segundo plano (ex.:
// prefetch do Diagnóstico) que já tratam a falha com retry/degradação
// silenciosa, pra não assustar o usuário com um erro técnico que ele não
// tem como agir.
async function getSilent(path, token) {
  return axios
    .get(path, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      console.error(error);
      throw error;
    });
}

async function customMessageGet(path, token, typeOfError) {
  return axios
    .get(path, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      customError(error, typeOfError);
    });
}

async function post(path, data, token) {
  return axios
    .post(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      handleErrors(error);
    });
}

async function toastPost(path, data, token) {
  return axios
    .post(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      const message =
        error.response?.data?.message ||
        error.response?.data ||
        error.message ||
        'Houve um erro na operação';
      toast.error(message);
    });
}

async function voidPost(path, data, token) {
  return axios
    .post(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      console.log(error);
    });
}

async function dlmPost(path, data, token) {
  return axios
    .post(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      console.log(error);
    });
}

async function altPost(path, data, token, message) {
  return axios
    .post(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      response;
      toast.success(`${message}`);
    })
    .catch((error) => {
      handleErrors(error);
      // console.log(error.response.data.error.message);
      // throw error;
    });
}

async function put(path, data, token) {
  return axios
    .put(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      response;
      toast.success('Atualização realizada com sucesso', config);
    })
    .catch((error) => {
      const message =
        error.response?.data?.message ||
        error.response?.data ||
        error.message ||
        'Houve um erro na operação';
      console.error('message:', message);
      toast.error('Houve um erro na execução da operação');
      // handleErrors(error);
    });
}

async function simplePut(path, data, token, done) {
  return axios
    .put(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      response;
      toast.success(`${done}`);
    })
    .catch((error) => {
      handleErrors(error);
    });
}

async function voidPut(path, data, token) {
  return axios
    .put(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      response;
    })
    .catch((error) => {
      handleErrors(error);
    });
}

async function dlmPut(path, data, token) {
  return axios
    .put(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      response;
    })
    .catch((error) => {
      console.log(error);
    });
}

async function returnPut(path, data, token) {
  return axios
    .put(path, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      handleErrors(error);
      throw error;
    });
}

async function remove(path, token) {
  // let loader = Vue.$loading.show();
  return axios
    .delete(path, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      handleErrors(error);
    });
  // finally(() => loader.hide());
}

async function voidRemove(path, token) {
  return axios
    .delete(path, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
      console.log(error);
    });
}

const MENSAGEM_ERRO_PADRAO =
  'Estamos com lentidão no momento. Tente novamente em instantes.';
const MENSAGEM_LENTIDAO =
  'O carregamento está demorando mais que o normal. Aguarde mais alguns instantes.';

// Códigos que indicam problema transitório do próprio sistema (timeout,
// sobrecarga, indisponibilidade momentânea) — o usuário não fez nada de
// errado, então um alerta vermelho de erro é mais alarmante do que precisa
// ser; um aviso amarelo de lentidão é mais honesto. Qualquer outro status
// (400 validação, 401/403 permissão, 404 não encontrado etc.) continua sendo
// um erro de verdade. Falha sem nenhuma resposta do servidor (timeout de
// rede, conexão caiu) entra no mesmo balde de "transitório".
const STATUS_FALHA_TRANSITORIA = new Set([408, 500, 502, 503, 504]);

function isFalhaTransitoria(error) {
  return (
    !error?.response || STATUS_FALHA_TRANSITORIA.has(error.response.status)
  );
}

// Abaixo desse tempo, uma falha 500/502/503/504/408 não foi por lentidão —
// foi um erro rápido (bug, exceção não tratada etc.), e dizer "aguarde, está
// demorando" pra algo que voltou em menos de 1 segundo é enganoso. Só quando
// a chamada realmente ficou perto do timeout (ou o timeout disparou de
// verdade, via error.code === 'ECONNABORTED') é que a demora é a causa real.
const LIMIAR_LENTIDAO_MS = 8000;

function foiLento(error) {
  return (
    error?.code === 'ECONNABORTED' ||
    (typeof error?.duracaoMs === 'number' &&
      error.duracaoMs >= LIMIAR_LENTIDAO_MS)
  );
}

// Uma falha crua do backend (ex.: Lambda derrubada por timeout) devolve só
// "Internal Server Error", sem nenhuma informação que ajude o usuário — troca
// por uma mensagem mais clara em PT-BR quando não há uma mensagem específica
// da aplicação (a de lentidão só quando a falha realmente demorou, a
// genérica pro resto).
function mensagemAmigavel(mensagem, error) {
  if (mensagem && !/internal server error/i.test(mensagem)) {
    return mensagem;
  }
  if (isFalhaTransitoria(error) && foiLento(error)) {
    return MENSAGEM_LENTIDAO;
  }
  return MENSAGEM_ERRO_PADRAO;
}

// toastId por endpoint (não um id fixo global): se o MESMO endpoint falhar
// várias vezes ao mesmo tempo (ex.: rajada que sobrecarrega o backend), o
// react-toastify colapsa num único toast em vez de empilhar vários idênticos.
// Usar um id fixo pra todo erro da aplicação esconderia um erro de uma tela
// diferente que aconteça por coincidência no mesmo instante — por isso o id
// é amarrado à URL que falhou, não a "qualquer erro".
const configErro = (error) => ({
  ...config,
  toastId: error?.config?.url || 'api-error'
});

// Aviso amarelo (não alarmante) pra falha transitória de sistema/timeout —
// nada que o usuário precise "corrigir", só esperar; erro vermelho pra tudo
// mais (validação, permissão, dado não encontrado), onde faz sentido chamar
// atenção de verdade.
function toastFalha(mensagem, error) {
  // Sem NENHUMA resposta do servidor (timeout de rede, bloqueio de CORS,
  // preflight OPTIONS que falhou etc.) não é a mesma coisa que o servidor
  // responder devagar — não temos como saber se a operação real teria
  // funcionado, e "aguarde" é enganoso quando não há nada rodando pra
  // esperar terminar. Visto ao vivo: tela carrega os dados normalmente e
  // ainda assim mostrava esse aviso, porque uma checagem de CORS interna
  // (checkCors/transactionalCheckCors) falha à parte da requisição real.
  // Melhor não alarmar o usuário por algo que ele não pode resolver esperando.
  if (!error?.response) {
    console.error(
      '[toastFalha] falha sem resposta do servidor (rede/CORS):',
      error
    );
    return;
  }
  const texto = mensagemAmigavel(mensagem, error);
  const opts = configErro(error);
  if (isFalhaTransitoria(error)) {
    toast.warning(texto, opts);
  } else {
    toast.error(texto, opts);
  }
}

export function handleApiErrors(error) {
  if (error?.response?.status) {
    const errorStatus = error.response.status;
    const errorMessage = error.response.data?.error?.message;
    const errorDataMessage = error.response.data?.message;
    const errorResponse = errorMessage || errorDataMessage;

    switch (errorStatus) {
      case 400:
        toastFalha(errorResponse, error);
        break;
      case 401:
        Auth.signOut({ global: true });
        toastFalha(errorResponse, error);
        break;
      case 403:
        toastFalha(errorResponse, error);
        break;
      case 404:
        toastFalha(errorResponse, error);
        break;
      case 405:
        toastFalha(errorResponse, error);
        break;
      case 408:
        toastFalha(errorResponse, error);
        break;
      case 413:
        toastFalha(errorResponse, error);
        break;
      case 415:
        toastFalha(errorResponse, error);
        break;
      case 429:
        toastFalha(errorResponse, error);
        break;
      case 500:
        toastFalha(errorResponse, error);
        break;
      case 502:
        toastFalha(errorResponse, error);
        break;
      case 503:
        toastFalha(errorResponse, error);
        break;
      case 504:
        toastFalha(errorResponse, error);
        break;
      case 505:
        toastFalha(errorResponse, error);
        break;
      default:
        toastFalha(errorResponse, error);
        break;
    }
  } else {
    toastFalha(null, error);
  }

  throw error;
}

export function postErrors(error) {
  if (error.response != null && error.response != undefined) {
    if (error.response.status != 500 && error.response.data?.error) {
      toastFalha(error.response.data?.error.message, error);
    } else if (error.response.status == 401) {
      Auth.signOut({ global: true });
    } else {
      toastFalha(error.response.data, error);
    }
  } else {
    toastFalha(error?.response?.data, error);
  }
  throw error;
}

export function handleErrors(error) {
  if (error.response != null) {
    if (error.response.status != 500 && error.response.data?.error) {
      /*big filter*/
      if (error.response.data?.error.message === 'No records to be recorded.') {
        console.log('1', error.response.data?.error.message);
      } else if (!error.response.data?.error.message.includes('Company')) {
        toastFalha(error.response.data?.error.message, error);
      }
    } else if (error.response.status == 401) {
      Auth.signOut({ global: true });
    } else {
      return toastFalha(error.response.data?.message, error);
    }
  } else {
    toastFalha(error?.response?.data?.message, error);
  }
  throw error;
}

export function customError(error, typeOfError) {
  if (error?.response?.data?.message) {
    let errMes = error.response.data?.message;
    if (
      errMes === 'Internal Server Error' &&
      typeOfError === 'no-company-workflow'
    ) {
      console.log('Empresa sem tags');
    }
  }
}

export function handleMessages(error) {
  if (error.message.length) {
    console.log(error.message);
  }
}

export function handleOtherErrors(product, status) {
  if (product === 'cadastros' && status == 400) {
    toast.error('Essa empresa não pertence a esse usuário');
  }
}

export function handleAdditionalErrors(product, status) {
  if (product === 'cadastros' && status == 400) {
    toast.error('Essa edição não pôde ser concluída');
  }
}
